import React from 'react';
import styled from 'styled-components';


interface PatientCardProps {
  name: string;
  insurance: string;
}


const PatientInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 8px 12px;
  width: fit-content;
  max-width: 100%;
  background-color: #ffffff;
`;

const PatientName = styled.span`
  font-size: 14px;
  color: #333333;
`;

const InsuranceBadge = styled.span`
  background-color: #e8f3ff;
  color: #007bff;
  font-size: 12px;
  padding: 4px 4px;
  border-radius: 12px;
  border: 1px solid #b3d9ff;
  white-space: nowrap;
  margin-left: 8px;
`;

const PatientCard: React.FC<PatientCardProps> = ({ name, insurance }) => {
  return (
    <PatientInfoContainer>
      <PatientName>{name}</PatientName>
      <InsuranceBadge>{insurance}</InsuranceBadge>
    </PatientInfoContainer>
  );
};

export default PatientCard;
